import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import CheckBox from "../../selection-controls/CheckBox.vue";
import { SelectBoxItem, LabelStrings } from '../types';
import { clickItemHandler, selectedItemsLabelHandler } from "../multiSelectUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiSelect',
  props: {
    disabled: { type: Boolean },
    value: null,
    labelStrings: null,
    items: null,
    errorMessage: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value?: SelectBoxItem[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  disabled?: boolean,
  value?: SelectBoxItem[],
  labelStrings: LabelStrings,
  items: SelectBoxItem[],
  errorMessage?: string,
};





const selectActive = ref<boolean>(false);
const inRange = (num: number, a: number, b=0) => (Math.min(a,b) <= num && num < Math.max(a,b));
const isIndeterminate = ref(props?.value && inRange(props?.value?.length, 1, props.items.length));

const isSelectedAll = computed({
  get: () => props?.value?.length === props.items.length,
  set: (newValue) => {
    selectedItems.value = newValue ? props.items : [];
  }
})

const selectedItems = computed({
  get: () => props.value ? props.value : [],
  set: (newValue) => {
    isIndeterminate.value = inRange(newValue.length, 1, props.items.length);
    emit('input', newValue);
  }
})

const selectedItemsLabel = computed(() =>
  selectedItemsLabelHandler(isSelectedAll.value, selectedItems.value, props.labelStrings)
);

const hideMultiSelectItems = () => selectActive.value = false;

const clickItem = (item: SelectBoxItem) => selectedItems.value = clickItemHandler(item, selectedItems.value);



return { __sfc: true,props, emit, selectActive, inRange, isIndeterminate, isSelectedAll, selectedItems, selectedItemsLabel, hideMultiSelectItems, clickItem, CheckBox }
}

})